import type { ReactElement } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import type { PpPrimaryButton } from '@noah-labs/fe-shared-ui-components';
import { useBreakpoints } from '../hooks/useBreakpoints';
import { LocalizedButton } from '../i18n/LocalizedButton';

export function LoginButton({ children, ...props }: PpPrimaryButton): ReactElement {
  const { pathname } = useLocation();
  const { isSmall } = useBreakpoints();

  let href = '/login';

  if (pathname.includes('/us/')) {
    href = '/us/login';
  } else if (pathname.includes('/eu/')) {
    href = '/eu/login';
  }

  const view = isSmall ? 'mobile' : 'desktop';

  return (
    <LocalizedButton data-qa={`signin-btn-${view}`} {...props} href={href}>
      {children}
    </LocalizedButton>
  );
}
